import React from 'react';
import ReactSelect, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';

import './style.scss';

const Option = props => {
  const onClick = e => {
    e.preventDefault();
    e.stopPropagation();
    props.selectOption(props.data);
  };
  return (
    <components.Option {...props}>
      <div>
        <label className="checkbox" onClick={onClick}>
          <input readOnly type="checkbox" checked={props.isSelected} />{' '}
          <span onClick={onClick}></span> <p onClick={onClick}>{props.label}</p>
        </label>
      </div>
    </components.Option>
  );
};

const MultiValue = props => (
  <components.MultiValue {...props}>
    <span>{props.data?.label ?? props.children}</span>
  </components.MultiValue>
);

export const Select = ({
  isMulti = false,
  isCreatable = false,
  ariaLabel = 'select',
  ...props
}) => {
  const [input, setInput] = React.useState('');

  const onInputChange = (value, { action }) => {
    if (!isMulti || (isMulti && action !== 'set-value')) setInput(value);
  };

  const styles = {
    multiValueRemove: (base, state) => {
      const canRemove = canRemoveOption(state);
      return canRemove ? { ...base, display: 'none' } : base;
    },
    multiValueLabel: (base, state) => {
      const canRemove = canRemoveOption(state);
      return canRemove ? { ...base, paddingRight: '6px' } : base;
    },
  };

  const defaultProps = {
    inputValue: input,
    onInputChange,
    isMulti,
    className: 'react-select',
    classNamePrefix: 'react-select',
    hideSelectedOptions: false,
    closeMenuOnSelect: !isMulti,
    components: {
      Option: isMulti ? Option : components.Option,
      MultiValue,
    },
    styles,
  };

  return isCreatable ? (
    <CreatableSelect {...defaultProps} {...props} aria-label={ariaLabel} />
  ) : (
    <ReactSelect {...defaultProps} {...props} aria-label={ariaLabel} />
  );
};

const canRemoveOption = selectState => {
  const option = selectState.data;
  const notClearable = !!(isCustomOption(option)
    ? selectState.options.find(opt => opt.value === option)?.notClearable
    : selectState.data.notClearable);
  return notClearable && selectState?.selectProps?.value.length === 1;
};
export const isCustomOption = opt => !opt.hasOwnProperty('value');

export default Select;
